<div class="summary">
  <summary-dynamic-profile
    [description]="description"
    [riskStatus]="riskStatus"
  ></summary-dynamic-profile>

  <div class="row">
    <div class="col-md-6">
      @if (riskRange && riskRange[1]) {
        <summary-risk [riskRange]="riskRange"></summary-risk>
      }
    </div>
    @if (productType == 'ASSURANCE_VIE') {
      <div class="col-md-6">
        <summary-ref
          [minValue]="recommendedEuroFoundShareMin"
          [maxValue]="recommendedEuroFoundShareMax"
          [value]="value"
        >
        </summary-ref>
      </div>
    }
  </div>
  <summary-list [title]="homeTitle" [options]="homeOptions"></summary-list>
  <summary-list
    [title]="investorTitle"
    [options]="investorOptions"
  ></summary-list>
</div>
